import { upperFirst, camelCase, last } from "lodash";

export const getNormalizedBlockName = (name: string): string => {
  const blockName = last(name.split("."));
  return upperFirst(camelCase(blockName));
};
